import { formatMessage } from "lib/globalize-util";
import { IAllocationDimension } from "helpers/allocation-dimension";
import { Validator } from "helpers/validator";
import { sanitizeHeaderNames } from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/utils";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";
import { buildColumnExpression } from "helpers/utils/build-column-expression";
import { isValidAttributeName } from "helpers/utils/allocation-dimension";

export class AttributeValidNameRule extends Validator<IAttributeData[], IAttributeDataError> {
    noAttributesColumns: string[];
    allocationDimension: IAllocationDimension;

    constructor(noAttributesColumns: string[], allocationDimension: IAllocationDimension) {
        super();
        this.noAttributesColumns = noAttributesColumns;
        this.allocationDimension = allocationDimension;
    }

    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        let invalidAttributeNames = [];
        if (!errors[RuleType.AttributeValidNameRule] && this.allocationDimension) {
            const headers = sanitizeHeaderNames(Object.keys(model[0] || {}));
            invalidAttributeNames = headers.reduce((acc, column) => {
                const expression = buildColumnExpression(column);
                if (
                    !this.noAttributesColumns.some((field) => expression.test(field)) &&
                    !this.allocationDimension.attributes.keys.some((attribute) =>
                        expression.test(attribute.display_name)
                    )
                ) {
                    !isValidAttributeName(column) && acc.push(column);
                }

                return acc;
            }, []);
        }

        const validationErrors = invalidAttributeNames.length
            ? {
                  ...errors,
                  [RuleType.AttributeValidNameRule]: formatMessage(
                      "Attribute(s) |attributes| contains invalid characters in the name. Only letters and numbers are allowed. (If your column name was appended here with _1, this means it exists multiple times within the file. Please rename it in your file and try again.)",
                      { attributes: invalidAttributeNames.join(", ") }
                  ),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
